import { render, staticRenderFns } from "./RcvE_Details2.vue?vue&type=template&id=3573fd72"
import script from "./RcvE_Details2.vue?vue&type=script&lang=js"
export * from "./RcvE_Details2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports